import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import PrimaryButton from "../../../../helperComponents/PrimaryButton";
import { serverLine } from "../../../../../controllers/network/serverLine";
import LoadingSection from "../../../../helperComponents/LoadingSection";
import { useTranslation } from "react-i18next";
import goTo from "../../../../../controllers/goTo";
import SemanticButton from "../../../../helperComponents/SemanticButton";
import Context from "../../../../../Context";
import { IoTimeOutline } from "react-icons/io5";
import { HiOutlineUser } from "react-icons/hi2";
import DetailsSection from "../../../../detailsPage/DetailsSection";
import DetailsPageBoilerplate from "../../../../detailsPage/DetailsPageBoilerplate";
import SecondaryText from "../../../../detailsPage/SecondaryText";
import BookingCreationPopup from "../../../../booking/BookingCreationPopup";
import getDateAndTimeOfBooking from "../../../../../controllers/getDateAndTimeOfBooking";

const CoachAndDuration = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  width: 100%;
  @media (max-width: 900px) {
    display: flex;
    flex-direction: row;
    gap: 80px;
    width: 100%;
  }
`;

const Icon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  /* display: inline-block; */
  font-size: 30px;
  opacity: 0.7;
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  opacity: 0.7;
  white-space: pre-line;
  font-size: 18px;
  line-height: 21px;

  @media (max-width: 900px) {
    text-align: justify;
    text-justify: inter-word;
    font-size: 15px;
    line-height: 1.3;
  }
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const ListItem = styled.li`
  font-size: 16px;
  margin-bottom: 8px;
  text-transform: capitalize;

  opacity: 0.7;
  font-size: 18px;
  line-height: 21px;

  &::before {
    content: "•";
    color: var(--element);
    margin-right: 8px;
  }

  @media (max-width: 900px) {
    text-align: justify;
    text-justify: inter-word;
    font-size: 15px;
    line-height: 1.3;
  }
`;

const EmployeeData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const EmployeeName = styled.div`
  font-weight: 800;
  opacity: 0.5;
  /*  */
  font-weight: 800;

  font-family: var(--headingFont);
  text-transform: capitalize;
  font-size: 13px;
`;

const IconAndText = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const IconText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

const IconMainText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  /*  */
  font-weight: 600;
  display: flex;
  opacity: 0.7;

  font-family: var(--headingFont);

  justify-content: center;
  align-items: center;
  font-size: 10px;
`;

const IconSecondaryText = styled.div`
  font-weight: 800;
  display: flex;
  justify-content: center;
  align-items: center;
  /*  */
  text-transform: capitalize;
  font-weight: 800;
  display: flex;

  font-family: var(--headingFont);

  color: var(--element);
  justify-content: center;
  align-items: center;
  font-size: 13px;
`;

function ActivityTypeDetails({ item, bookingData, doLoading }) {
  const { membershipPlans, updateMembershipPlans, setForm, loggedInUserID } =
    useContext(Context);
  const [isBooked, setIsBooked] = useState(bookingData);
  const [state, setState] = useState(item);
  const [bookingInProgress, setBookingInProgress] = useState(false);

  useEffect(() => {
    updateMembershipPlans();
  }, []);

  const { t } = useTranslation();

  let bookButtons = [
    <PrimaryButton
      onClick={() => {
        doBooking("SOLO");
      }}
      style={{ width: "100%", borderRadius: "10px" }}
    >
      Réserver
    </PrimaryButton>,
  ];

  if (item.allowPairParticipation) {
    bookButtons.push(
      <PrimaryButton
        onClick={() => {
          doBooking("PAIR");
        }}
        style={{ width: "100%", borderRadius: "10px" }}
      >
        Réserver (Pair)
      </PrimaryButton>
    );
  }

  if (item.allowTrioParticipation) {
    bookButtons.push(
      <PrimaryButton
        onClick={() => {
          doBooking("TRIO");
        }}
        style={{ width: "100%", borderRadius: "10px" }}
      >
        Réserver (Trio)
      </PrimaryButton>
    );
  }

  let cancelBookingButton = null;

  if (bookingData)
    cancelBookingButton = (
      <PrimaryButton
        onClick={() => {
          if (bookingData) cancelBooking(bookingData.participationCountType);
        }}
        textStyle={{ color: "var(--elementDim)" }}
        icon={null}
        style={{
          width: "100%",
          borderRadius: "10px",
          background: "var(--surface)",
          border: "1px solid var(--border)",
          boxShadow: "none",
        }}
      >
        {t("activityItemCancelBooking")} ({bookingData.participationCountType}){" "}
        {bookingData.status == "PENDING" ? `(${t("pending")})` : null}
      </PrimaryButton>
    );

  if (!membershipPlans) return <LoadingSection />;
  let membershipIdVsPlan = {};

  for (let item of membershipPlans) {
    membershipIdVsPlan[item._id] = item;
  }

  let theButton = isBooked ? cancelBookingButton : bookButtons;

  if (bookingInProgress) theButton = <LoadingSection />;

  let textContent = (
    <>
      <CoachAndDuration>
        <SemanticButton
          onClick={goTo("/employee/?itemID=" + item.employee._id)}
        >
          <IconAndText style={{ cursor: "pointer" }}>
            <Icon>
              <HiOutlineUser />
            </Icon>
            <IconText>
              <IconMainText> {t("activityItemCoach")} </IconMainText>
              <IconSecondaryText>{item.employee.name} </IconSecondaryText>
            </IconText>
          </IconAndText>
        </SemanticButton>

        <IconText>
          <IconAndText>
            <Icon>
              <IoTimeOutline />
            </Icon>

            <IconText>
              <IconMainText>{t("activityItemDuration")}</IconMainText>
              <IconSecondaryText>{item.duration} min</IconSecondaryText>
            </IconText>
          </IconAndText>
        </IconText>
      </CoachAndDuration>

      <SecondaryText>{item.description}</SecondaryText>

      <DetailsSection title={t("activityItemDetails")}>
        <List>
          <SecondaryText>
            {t("activityItemParticipationType")} :{" "}
            {item.participationType ? t(item.participationType) : "N/A"}
          </SecondaryText>
          <SecondaryText>
            {t("activityItemMembershipType")} :{" "}
            {item.membershipPlanIDs
              ? item.membershipPlanIDs
                  .map((itemID) => {
                    let item = membershipIdVsPlan[itemID];
                    return item.name;
                  })
                  .join(", ")
              : "N/A"}
          </SecondaryText>
        </List>
      </DetailsSection>

      <DetailsSection title={t("activityItemAboutCoach")}>
        <EmployeeData>
          <EmployeeName>{item.employee.name}</EmployeeName>
          <SecondaryText>{item.employee.description}</SecondaryText>
        </EmployeeData>
      </DetailsSection>
    </>
  );

  let secondaryTitle = null;

  if (bookingData) {
    secondaryTitle = `${t("booking")} :


      ${getDateAndTimeOfBooking({
        activityType: item,
        bookingData,
      })}
    `;
  }

  return (
    <DetailsPageBoilerplate
      topRightData={
        item.participationType ? item.participationType.toLowerCase() : null
      }
      title={item.title}
      secondaryTitle={secondaryTitle}
      imageData={item.image}
      buttons={[theButton]}
    >
      {textContent}
    </DetailsPageBoilerplate>
  );

  function doThePopup({ onSuccess, participationCountType }) {
    setForm({
      component: (
        <BookingCreationPopup
          activityType={item}
          participationCountType={participationCountType}
          onSuccess={onSuccess}
        />
      ),
    });
  }

  async function doBooking(participationCountType) {
    if (!loggedInUserID) {
      goTo("/signup")();
      return window.popupAlert(t("loginRequired"));
    }

    try {
      doThePopup({
        participationCountType,
        onSuccess: () => {
          doLoading(true);
        },
      });
    } catch (e) {
      if (e.message.toUpperCase() == "PLEASE! PURCHASE ACTIVITY") {
        goTo("/recharge-activity")();
      }

      window.popupAlert(e.message);
      setBookingInProgress(false);
    }
  }

  async function cancelBooking(participationCountType) {
    try {
      await serverLine.post("/activity-booking", {
        activityTypeID: item._id,
        participationCountType: participationCountType,
        action: "UNBOOK",
      });
    } catch (e) {
      window.popupAlert(e.message);
      setBookingInProgress(false);
    }

    await doLoading(true);
  }
}

export default ActivityTypeDetails;
